module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/id_1-bb6335b74ca8f1ead721d3b59a28b01e.jpg";